// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----Text-module---root---UhyL-","isBody":"src-components----Text-module---isBody---NFI0y","isHtml":"src-components----Text-module---isHtml---23St5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Text.module.css
// module id = 304
// module chunks = 35783957827783